import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import accounting from 'accounting';
import CssTransition from '../../components/Transition/CssTransition';

import ShareDrawer from '../../components/ShareDrawer';
import { isLongText } from '../../components/Shared/commonFunctions';

import { TransitionGroup } from 'react-transition-group';

import DonationAmount from '../../components/Donation/DonationAmount';
import CustomDonation from '../../components/Donation/CustomDonation';
import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import Title from '../../components/Donation/Title';
import { setOverlayPartnerVisible, onBackWithinCard } from '../Widget/actions';

import { isPortrait } from '../../utils/size';

import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer
} from '../DefaultStyles/Shared';

import { CardTypes } from '../../utils/enums';
import { selectAmount, donateMore, onCustomAmountChanged } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

const DonationAmountsContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-content: flex-end;
    align-items: flex-end;

    @media (max-width: 30em) {
        flex-wrap: wrap;
        justify-content: space-between;
        flex-direction: none;

        > div {
            margin-bottom: 0.5em;
        }
        > div:nth-child(1) {
            margin-right: 0.25em;
        }
        > div:nth-child(2) {
            margin-left: 0.25em;
        }
        > div:nth-child(3) {
            margin-right: 0.25em;
            margin-bottom: 0px;
        }
        > div:nth-child(4) {
            margin-left: 0.25em;
            margin-bottom: 0px;
        }
    }

    @media (min-width: 30.0625em) {
        flex-direction: row;
        padding-bottom: 8px;
        justify-content: space-between;

        > div {
            margin-bottom: 1px;
        }
        > div:nth-child(1) {
            margin-right: 0.25em;
        }

        > div:nth-child(2) {
            margin-left: 0.25em;
            margin-right: 0.25em;
        }

        > div:nth-child(3) {
            margin-left: 0.25em;
            margin-right: 0.25em;
        }

        > div:nth-child(4) {
            margin-left: 0.25em;
        }
    }

    &.transition-enter {
        opacity: 0;
    }

    &.transition-enter.transition-enter-active {
        opacity: 1;
        transition: opacity 0.4s ease-in;
    }

    &.transition-exit {
        opacity: 1;
    }

    &.transition-exit.transition-exit-active {
        opacity: 0;
        transition: opacity 0.1s ease-in;
    }
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (max-width: 30em) {
        ${props => (props.isCustomDonation ? 'max-height: calc(90% - 146px)' : '')};
    }
`;

const CloseButtonWrapper = styled.div`
    position: absolute;
    right: 0px;
    top: 12px;
    width: 135px;
    height: 32px;
    background: #fff;
`;

const CloseButton = styled.div`
    width: 34px;
    height: 34px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 34px;
    cursor: pointer;
    color: #ff245e;
    float: right;
`;

const AbsoluteContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`;

const DonationWrapper = styled.div`
    display: flex;
    flex: 1;
    ${() => !isPortrait() && `align-items: center`};
    width: 100%;
    margin-bottom: 0px;
`;

const Back = styled.span`
    cursor: pointer;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    color: #008eff;
`;
class DonationStart extends React.Component {
    render() {
        return (
            <Container isCustomDonation={this.props.isCustomDonation}>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <Body isCustomDonation={this.props.isCustomDonation}>
                    {this.props.isMultiActionsCard && (
                        <CloseButtonWrapper>
                            <CloseButton
                                onClick={() =>
                                    this.props.onBackWithinCard(
                                        this.props.actionIdentifier,
                                        this.props.card
                                    )
                                }
                            >
                                +
                            </CloseButton>
                        </CloseButtonWrapper>
                    )}
                    <WidgetHeader />
                    <Content>
                        <Title
                            shortActionName={this.props.shortActionName}
                            onPartnerClick={this.props.setOverlayPartnerVisible}
                            isLocalRepLoading={false}
                            isLongText={isLongText(this.props.shortActionName, 60)}
                            isExtraLongText={isLongText(this.props.shortActionName, 95)}
                        />
                        <DetailsContainer>
                            <Details hasPhoto={false}>
                                {this.props.isMobileResolution ? (
                                    <TransitionGroup>
                                        <CssTransition>
                                            <Description
                                                isLocalRepLoading={false}
                                                isLongText={isLongText(
                                                    this.props.description,
                                                    90
                                                )}
                                                isExtraLongText={isLongText(
                                                    this.props.description,
                                                    160
                                                )}
                                                onClick={e =>
                                                    this.props.setOverlayPartnerVisible(
                                                        true,
                                                        e,
                                                        false
                                                    )
                                                }
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.description
                                                }}
                                            />
                                        </CssTransition>
                                    </TransitionGroup>
                                ) : (
                                    <Description
                                        isLocalRepLoading={false}
                                        isLongText={isLongText(
                                            this.props.description,
                                            90
                                        )}
                                        isExtraLongText={isLongText(
                                            this.props.description,
                                            160
                                        )}
                                        onClick={e =>
                                            this.props.setOverlayPartnerVisible(
                                                true,
                                                e,
                                                false
                                            )
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.description
                                        }}
                                    />
                                )}
                                {this.props.isMultiDonation && (
                                    <Back
                                        onClick={() =>
                                            this.props.onBackWithinCard(
                                                this.props.actionIdentifier,
                                                this.props.card
                                            )
                                        }
                                    >
                                        Select a different charity
                                    </Back>
                                )}
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <DonationWrapper isPortrait={isPortrait()}>
                        <TransitionGroup style={{ width: '100%', height: '100%' }}>
                            {!this.props.isCustomDonation && (
                                <CssTransition key={this.props.isCustomDonation ? 1 : 0}>
                                    <DonationAmountsContainer id="DonationWrapper">
                                        {this.props.amounts
                                            .map(amount => (
                                                <DonationAmount
                                                    key={amount}
                                                    amount={amount}
                                                    isMostPopular={
                                                        this.props
                                                            .defaultDonationAmount ===
                                                        amount
                                                    }
                                                    onSelectAmount={() =>
                                                        this.props.selectAmount(amount)
                                                    }
                                                />
                                            ))
                                            .concat(
                                                <DonationAmount
                                                    key="Custom"
                                                    amount={0}
                                                    isMostPopular={false}
                                                    onSelectAmount={() =>
                                                        this.props.donateMore(true)
                                                    }
                                                />
                                            )}
                                    </DonationAmountsContainer>
                                </CssTransition>
                            )}
                        </TransitionGroup>
                    </DonationWrapper>
                </Body>
                <Footer>
                    <ShareDrawer rightAlign backgroundColor={'#fff'} />
                </Footer>
                <TransitionGroup component={AbsoluteContainer}>
                    {this.props.isCustomDonation && (
                        <CssTransition
                            key={this.props.isCustomDonation ? 1 : 0}
                            timeoutInMs={this.props.isMobileResolution ? 500 : 300}
                        >
                            <CustomDonation
                                onCancelDonateMore={() => this.props.donateMore(false)}
                                customAmount={this.props.customAmount}
                                onSubmit={values => {
                                    this.props.cacheFormData(values);
                                    this.props.selectAmount(
                                        accounting.unformat(values.amount)
                                    );
                                }}
                            />
                        </CssTransition>
                    )}
                </TransitionGroup>
            </Container>
        );
    }
}

DonationStart.propTypes = {
    selectAmount: PropTypes.func.isRequired,
    card: PropTypes.object.isRequired,
    donateMore: PropTypes.func.isRequired,
    shortActionName: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    defaultDonationAmount: PropTypes.number,
    amounts: PropTypes.arrayOf(PropTypes.number).isRequired,
    isCustomDonation: PropTypes.bool.isRequired,
    customAmount: PropTypes.string,
    isMobileResolution: PropTypes.bool,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isMultiDonation: PropTypes.bool.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        return {
            shortActionName:
                state.widget.activeAction.shortName || state.widget.activeAction.name,
            partnerName: state.widget.activeAction.partner.name,
            description: state.widget.activeAction.description,
            defaultDonationAmount: state.widget.activeAction.defaultDonationAmount,
            amounts: state.widget.activeAction.amounts,
            selectedAmount: state.donation.selectedAmount,
            isCustomDonation: state.donation.isCustomDonation,
            customAmount: state.donation.customAmount,
            isMobileResolution: state.widget.isMobileResolution,
            regularRowSize: state.widget.regularRowSize,
            actionIdentifier: state.widget.activeAction.identifier,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isMultiDonation:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multiDonation
        };
    },
    {
        selectAmount,
        donateMore,
        onCustomAmountChanged,
        setOverlayPartnerVisible,
        onBackWithinCard,
        cacheFormData
    }
)(DonationStart);



// WEBPACK FOOTER //
// ./src/containers/Donation/DonationStart.jsx